import React, { useEffect, useState, useContext } from "react";
import { Table, Select, message, Modal, Input } from "antd";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Link } from "react-router-dom";
import {

  fetchPayrollBySearch,
  calculatePayrolls,
  sendIndividualPayslip,
  sendBulkPayslips,
  updateManualOvertimePay,
  fetchNoPayBreakdown
} from "../../service/payrollservice";
import { sendBulkSMS, sendIndividualSMS } from "../../service/smsService";
import { Spin } from "antd";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import { Dropdown, Menu, Button } from "antd";
import { DownOutlined, SendOutlined, MailOutlined, EditOutlined, SaveOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
const { Option } = Select;
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";

function Payslip() {
  const { user } = useContext(UserContext);
  const currentYear = dayjs().year();
  const currentMonth = new Date().getMonth();
  const [payrollData, setPayrollData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth + 1);
  const [searchMonth, setSearchMonth] = useState(null);
  const [search, setSearch] = useState("");
  const [loading2, setLoading2] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [searchYear, setSearchYear] = useState(null);
  const [center, setCenter] = useState(null);
  const [branch, setBranch] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [epf_number, setEpf] = useState("");
  const [editingKey, setEditingKey] = useState("");
  const [editedOvertime, setEditedOvertime] = useState({});
  const [isNoPayModalVisible, setIsNoPayModalVisible] = useState(false);
  const [noPayData, setNoPayData] = useState(null);
  const [noPayLoading, setNoPayLoading] = useState(false);

  const handleViewNoPay = async (record) => {
    try {
      setNoPayLoading(true);
      setIsNoPayModalVisible(true);
      const result = await fetchNoPayBreakdown(record._id);
      if (result && result.status === 'success') {
        setNoPayData(result.data);
      } else {
        message.error("Failed to load No Pay details");
      }
    } catch (err) {
      console.error("Error fetching No Pay details:", err);
      message.error("Error fetching No Pay details");
    } finally {
      setNoPayLoading(false);
    }
  };

  const isEditing = (record) => record._id === editingKey;
  const handleYearChange = (date, dateString) => {
    setSelectedYear(dateString);
  };

  const handleSearchYearChange = (date, dateString) => {
    setSearchYear(dateString);
  };

  const centerOption = [
    { value: "OKI", label: "OKI" },
    { value: "OKIDS", label: "OKIDS" },
    { value: "OKIT", label: "OKIT" },
  ];

  const branchOptions = [
    { value: "kaduwela", label: "Kaduwela" },
    { value: "wattala", label: "Wattala" },
    { value: "negombo", label: "Negombo" },
    { value: "kiribathgoda", label: "Kiribathgoda" },
    { value: "kandana", label: "Kandana" },
  ];

  const handleSendBulkSMS = async () => {
    try {
      const recipients = payrollData.map((record) => record.employee.phone_number);
      const message = "Your payslip for this month is ready. You can now download it from the employee portal.";
      await sendBulkSMS(recipients, message);
      message.success("SMS notifications sent successfully to all employees");
    } catch (error) {
      console.error("Error sending bulk SMS:", error);
      message.error("Failed to send SMS notifications");
    }
  };

  const handleSendIndividualSMS = async (record) => {
    try {
      const phoneNumber = record.employee.phone_number;
      const message = `Dear ${record.employee.full_name || `${record.employee.first_name} ${record.employee.last_name}`}, your payslip for this month is ready. You can now download it from the employee portal.`;
      await sendIndividualSMS(phoneNumber, message);
      message.success("SMS notification sent successfully");
    } catch (error) {
      console.error("Error sending individual SMS:", error);
      message.error("Failed to send SMS notification");
    }
  };

  const handleSendPayslip = async (payrollId) => {
    try {
      setLoading(true);
      const result = await sendIndividualPayslip(payrollId);
      if (result.success) {
        message.success("Payslip sent successfully!");
      } else {
        message.error(result.message);
        console.error("Error details:", result.error);
      }
    } catch (error) {
      message.error("Failed to send payslip");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkSend = async () => {
    try {
      const month = selectedMonth;
      const year = selectedYear;
      if (!confirm(`Send payslips to all employees for ${month}/${year}?`)) return;
      const result = await sendBulkPayslips(month, year);
      if (result.success) {
        message.success(result.message);
        if (result.data) {
          const successCount = result.data.filter((r) => r.status === "success").length;
          const failedCount = result.data.filter((r) => r.status === "failed").length;
          Modal.info({
            title: "Bulk Send Results",
            content: (
              <div>
                <p>Successfully sent: {successCount}</p>
                <p>Failed to send: {failedCount}</p>
                {failedCount > 0 && (
                  <Button
                    type="link"
                    onClick={() => {
                      const failedEmails = result.data
                        .filter((r) => r.status === "failed")
                        .map((r) => `${r.employeeName} (${r.email || "no email"}): ${r.message}`);
                      Modal.info({
                        title: "Failed Emails",
                        content: (
                          <div>
                            {failedEmails.map((msg, i) => (
                              <p key={i}>{msg}</p>
                            ))}
                          </div>
                        ),
                        width: 800,
                      });
                    }}
                  >
                    View failed attempts
                  </Button>
                )}
              </div>
            ),
            width: 600,
          });
        }
      } else {
        message.error(result.message);
        console.error("Error details:", result.error);
      }
    } catch (error) {
      message.error("An unexpected error occurred");
      console.error("Unexpected error:", error);
    }
  };

  const editOvertime = (record) => {
    if (!user?.permissions || !hasPermission(user.permissions, "HRM", "Payroll", "edit", "Payslip")) {
      message.error("You don't have permission to edit payslips");
      return;
    }
    setEditingKey(record._id);
    setEditedOvertime({
      ...editedOvertime,
      [record._id]: record.overtimePay || "0",
    });
  };

  const handleOvertimeChange = (value, recordId) => {
    setEditedOvertime({
      ...editedOvertime,
      [recordId]: value,
    });
  };

  const saveOvertime = async (record) => {
    const newOvertime = parseFloat(editedOvertime[record._id]) || 0;
    if (newOvertime < 0) {
      message.error("Overtime pay cannot be negative");
      return;
    }

    try {
      // Update manual overtime via API
      const response = await updateManualOvertimePay(record._id, newOvertime);

      // Update local state
      if (response.status === 'success') {
        const updatedRecord = response.data;
        const newData = [...payrollData];
        const index = newData.findIndex((item) => record._id === item._id);
        if (index !== -1) {
          newData[index] = {
            ...newData[index],
            ...updatedRecord,
          };
          setPayrollData(newData);
          setEditingKey("");
          message.success("Overtime updated successfully");
        }
      }
    } catch (error) {
      message.error("Failed to update overtime");
      console.error("Error:", error);
    }
  };
  const cancelEdit = () => {
    setEditingKey("");
  };



  const handleFileDownload = (value) => {
    switch (value) {
      case "okids-payrolls":
        handleOKIDSExcelExport();
        break;
      case "payrolls":
        handleAllExcelExport();
        break;
      case "etf-file":
        downloadOKIDSETFFile();
        break;
      case "epf-file":
        downloadOKIDSEPFFile();
        break;
      default:
        break;
    }
  };

  const menu = (
    <Menu onClick={(e) => handleFileDownload(e.key)}>
      <Menu.Item key="payrolls">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="btn" style={{ marginRight: "4px" }}>
            Payrolls
          </label>
          <img src="assets/img/icons/excel.svg" alt="excel" />
        </div>
      </Menu.Item>
      <Menu.Item key="etf-file">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="btn" style={{ marginRight: "4px" }}>
            ETF File
          </label>
          <img src="assets/img/icons/excel.svg" alt="excel" />
        </div>
      </Menu.Item>
      <Menu.Item key="epf-file">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="btn" style={{ marginRight: "4px" }}>
            EPF File
          </label>
          <img src="assets/img/icons/excel.svg" alt="excel" />
        </div>
      </Menu.Item>
    </Menu>
  );

  // const fetchRecordsByMonthAndYear = async () => {
  //   setLoading(true);
  //   const records = await fetchAllPayrolls(selectedMonth, selectedYear);
  //   setLoading(false);
  //   if (records) {
  //     setPayrollData(records.data);
  //   } else {
  //     setPayrollData([]);
  //   }
  // };

  const generatePayrolls = async () => {
    // Calculate dates if not set
    let calcStartDate = startDate;
    let calcEndDate = endDate;
    console.log("Start and End Dates", startDate, endDate)
    // Ensure selectedYear is a number for calculations
    const yearNum = typeof selectedYear === 'string' ? parseInt(selectedYear, 10) : selectedYear;

    if (!calcStartDate || !calcEndDate) {
      const previousMonth = selectedMonth === 1 ? 12 : selectedMonth - 1;
      const yearForPreviousMonth = selectedMonth === 1 ? yearNum - 1 : yearNum;
      calcStartDate = `${yearForPreviousMonth}-${String(previousMonth).padStart(2, "0")}-19`;
      calcEndDate = `${yearNum}-${String(selectedMonth).padStart(2, "0")}-18`;
      setStartDate(calcStartDate);
      setEndDate(calcEndDate);
    }

    setLoading2(true);
    try {
      const records = await calculatePayrolls(calcStartDate, calcEndDate);
      setPayrollData(records.data);
    } catch (error) {
      console.error('Error in generatePayrolls:', error);
    } finally {
      setLoading2(false);
    }
  };

  const getSeachRecord = async () => {
    const records = await fetchPayrollBySearch({
      setLoading,
      month: searchMonth,
      year: searchYear,
      epf_number,
      name: search,
      center,
      branch,
    });
    if (records) {
      setPayrollData(records.data);
    } else {
      setPayrollData([]);
    }
  };

  const handleSearch = () => {
    getSeachRecord();
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthNumber - 1];
  };

  const toNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const toTwoDecimalNumber = (value) => {
    const rounded = Math.round((toNumber(value) + Number.EPSILON) * 100) / 100;
    return Number(rounded.toFixed(2));
  };

  const getVerifiedWorkDays = (record) => {
    const candidates = [record?.workDays, record?.daysWorked, record?.workingDays];
    const rawDays = candidates.find((value) => Number.isFinite(Number(value)));

    if (rawDays == null) return 0;

    const normalized = Number(rawDays);
    if (normalized < 0) return 0;

    return Math.min(31, Math.round(normalized));
  };

  const generatePayslipPDF = (record) => {
    console.log("Generating Pay Slip ===========", record)
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 15;
    const contentWidth = pageWidth - margin * 2;

    // Formatting Helper
    const formatCurrency = (amount) => {
      const num = parseFloat(amount);
      if (isNaN(num) || num === null || num === undefined) return "0.00";
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Header Section
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("OKI INTERNATIONAL SCHOOL", pageWidth / 2, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("WATTALA", pageWidth / 2, 28, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Use the payroll record's actual month and year instead of the selected dropdown values
    const payrollMonth = record.month || selectedMonth;
    const payrollYear = record.year || selectedYear;
    const monthName = getMonthName(payrollMonth);
    doc.text(`Salary for the month of ${monthName} ${payrollYear}`, margin, 38);

    // Employee Details Section
    doc.autoTable({
      startY: 42,
      margin: { left: margin, right: margin },
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 1 },
      columnStyles: { 0: { fontStyle: "bold", cellWidth: 30 } },
      body: [
        [
          "EPF NUMBER:",
          record.employee.epf_number || "-"
        ],
        [
          "Branch:",
          record.employee.branch || "OKI - Wattala"
        ],
        [
          "Name:",
          record?.employee.full_name || `${record?.employee.first_name || ""} ${record?.employee.last_name || ""}`
        ],
        [
          "ID Number:",
          record.employee.nic || "-"
        ]
      ],
    });

    let currentY = doc.lastAutoTable.finalY + 5;

    // Table Common Styles
    const tableStyles = {
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 1.5, overflow: 'hidden' },
      columnStyles: {
        0: { halign: 'left', cellWidth: contentWidth * 0.6 },
        1: { halign: 'right', cellWidth: contentWidth * 0.4 }
      },
      margin: { left: margin, right: margin },
    };

    const earningsBody = [
      ["Basic Salary", formatCurrency(record.basicSalary)],
      ["Budget Allowance (1000)", parseFloat(record.allowance1000) > 0 ? formatCurrency(record.allowance1000) : "0.00"],
      ["Budget Allowance (2500)", parseFloat(record.allowance2500) > 0 ? formatCurrency(record.allowance2500) : "0.00"],
    ];


    // if (record.allowances && record.allowances.length > 0) {
    //      record.allowances.forEach(allow => {
    //          earningsBody.push([allow.name, formatCurrency(allow.amount)]);
    //      });
    // }
    //
    // console.log("Record Allowances",earningsBody)


    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: earningsBody,
    });
    currentY = doc.lastAutoTable.finalY;

    // 3. TOTAL BASIC
    // Using simple line for separation
    doc.setDrawColor(200, 200, 200);
    doc.line(margin, currentY, pageWidth - margin, currentY);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["Total Basic", formatCurrency(record.totalBasic)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY;

    // 4. TOTAL EARNINGS (Gross Pay) include OT etc
    const otherEarningsBody = [];
    // Always show OT
    otherEarningsBody.push(["OT", formatCurrency(record.overtimePay || 0)]);

    if (otherEarningsBody.length > 0) {
      doc.autoTable({
        startY: currentY,
        ...tableStyles,
        body: otherEarningsBody
      });
      currentY = doc.lastAutoTable.finalY;
    }


    doc.setDrawColor(0, 0, 0); // darker line
    doc.line(margin, currentY, pageWidth - margin, currentY);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["Gross pay", formatCurrency(record.grossPay)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY + 5;

    const deductionsBody = [];
    deductionsBody.push(["Less : No Pay", formatCurrency(record.totalNoPay || 0)]);
    deductionsBody.push(["08% EPF", formatCurrency(record.epf)]);
    deductionsBody.push(["WS & LS Contribution", formatCurrency(record.wsLsContribution || 0)]);
    deductionsBody.push(["Salary advance", formatCurrency(record.salaryAdvance || 0)]);
    deductionsBody.push(["Staff loan", formatCurrency(record.staffLoan || 0)]);
    deductionsBody.push(["Festival advance", formatCurrency(record.festivalAdvance || 0)]);
    deductionsBody.push(["Other", formatCurrency(record.otherDeduction || 0)]);
    deductionsBody.push(["Payee tax", formatCurrency(record.payeTax || 0)]);
    console.log("Payee tax", record.payeTax)
    // Add other dynamic deductions
    if (record.otherDeductions && Array.isArray(record.otherDeductions)) {
      record.otherDeductions.forEach(ded => {
        const amount = ded.paymentType === "recurring" ? ded.installement : ded.amount;
        deductionsBody.push([ded.description || "Other Deduction", formatCurrency(amount)]);
      });
    }

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: deductionsBody,
    });
    currentY = doc.lastAutoTable.finalY;

    // 6. TOTAL DEDUCTIONS
    doc.line(margin, currentY, pageWidth - margin, currentY);
    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["TOTAL DEDUCTIONS", formatCurrency(record.sumOfAllDeductions)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY + 5;

    // 7. NET SALARY PAYABLE
    // Double Border for Emphasis
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    // Top line
    doc.line(margin, currentY, pageWidth - margin, currentY);
    // Button line will be handled by next content or manual draw

    // Calculate values locally just for verification or display consistency if needed, but primarily use record
    // const calculatedNet = parseFloat(record.grossPay) - parseFloat(record.sumOfAllDeductions);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      styles: { fontSize: 11, cellPadding: 3 },
      body: [
        ["NET SALARY", formatCurrency(record.netPay)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
        if (data.column.index === 1) {
          //  data.cell.styles.textColor = [0, 0, 0]; 
        }
      }
    });
    currentY = doc.lastAutoTable.finalY;

    doc.line(margin, currentY, pageWidth - margin, currentY);
    doc.setLineWidth(0.1); // reset
    currentY += 6;

    // Add Travelling & attendance reimbursement component breakdown and calculated total
    const allAllowances = Array.isArray(record.allowances) ? record.allowances : [];
    
    const matchers = [
      { key: 'other', label: 'Other Allowances', test: (n) => /1\]/i.test(n) || /other\s+allowances?/i.test(n) },
      { key: 'travelling', label: 'Travelling Allowance', test: (n) => /2\]/i.test(n) || (/travell?ing/i.test(n) && !/&/i.test(n)) },
      { key: 'attendance', label: 'Attendance Reimbursement', test: (n) => /3\]/i.test(n) || /attendance\s+reimbursement/i.test(n) },
      { key: 'fixed', label: 'Fixed Allowance', test: (n) => /4\]/i.test(n) || /fixed\s+allowance/i.test(n) || /rs\.?\s*1000\s+or/i.test(n) }
    ];

    const matchedIds = new Set();
    const reimbursementItems = [];
    let calculatedTravellingTotal = 0;

    matchers.forEach(({ label, test }) => {
      const found = allAllowances.find(a => {
        const name = (a.allowanceType?.name || a.name || '').trim();
        const id = a._id?.toString() || name;
        return !matchedIds.has(id) && test(name);
      });
      if (found) {
        matchedIds.add(found._id?.toString() || (found.allowanceType?.name || found.name));
        const amt = parseFloat(found.amount || 0);
        calculatedTravellingTotal += amt;
        reimbursementItems.push({
          name: found.allowanceType?.name || label,
          amount: amt,
          showPaySlip: found.allowanceType?.showPaySlip ?? found.showPaySlip ?? true
        });
      }
    });

    const directMatch = allAllowances.find(a => {
      const name = (a.allowanceType?.name || a.name || '').trim();
      const id = a._id?.toString() || name;
      return !matchedIds.has(id) && /travell?ing\s*&\s*attendance\s*reimbursement/i.test(name);
    });
    if (directMatch) {
      calculatedTravellingTotal += parseFloat(directMatch.amount || 0);
    }

    const finalTravellingReimbursement = calculatedTravellingTotal > 0
      ? calculatedTravellingTotal
      : (parseFloat(record.travellingReimbursement) || parseFloat(directMatch?.amount) || 0);

    const reimbursementBody = [];
    // Show individual items if showPaySlip = true
    reimbursementItems.forEach(item => {
      if (item.showPaySlip && item.amount > 0) {
        reimbursementBody.push([item.name, formatCurrency(item.amount)]);
      }
    });

    // Show final calculated total
    reimbursementBody.push(["Travelling & attendance reimbursement", formatCurrency(finalTravellingReimbursement)]);

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: reimbursementBody
    });
    currentY = doc.lastAutoTable.finalY + 3;
    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: [
        ["Incentive", formatCurrency(record.allowances?.find(value => value.allowanceType.name === "Incentive")?.amount) || 0]
      ]
    });
    currentY = doc.lastAutoTable.finalY + 3;
    console.log("Travelling & attendance reimbursement", record.allowances?.find(value => value.allowanceType.name === "Travelling & attendance reimbursement")?.amount)
    // Banked Salary & Trv. Claim section
    const baseNetPay = parseFloat(record.netPay || 0);
    const incentiveAmt = parseFloat(record.allowances?.find(value => value.allowanceType.name === "Incentive")?.amount || 0);
    const totalBanked = parseFloat(record.totalPay || 0) > baseNetPay
      ? parseFloat(record.totalPay || 0)
      : (baseNetPay + finalTravellingReimbursement + incentiveAmt);
    if (totalBanked > 0) {
      const bankName = record.employee.bank_name || record.employee.bank || 'NDB';
      doc.autoTable({
        startY: currentY,
        theme: "plain",
        styles: { fontSize: 9, cellPadding: 1.5, overflow: 'linebreak' },
        columnStyles: {
          0: { halign: 'left', cellWidth: contentWidth * 0.65 },
          1: { halign: 'right', cellWidth: contentWidth * 0.35 }
        },
        margin: { left: margin, right: margin },
        body: [
          [`Banked Salary & Trv. Claim to ${bankName}`, formatCurrency(totalBanked)]
        ]
      });
      currentY = doc.lastAutoTable.finalY + 5;
    }

    // Received Salary & Traveling reimbursement section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Received Salary & Traveling reimbursement ........................................................", margin, currentY);
    currentY += 8;

    const employerBody = [
      ["12% EPF", formatCurrency(record.epf12)],
      ["20% EPF", formatCurrency(record.epf20 || 0)],
      ["03% ETF", formatCurrency(record.etf3)]
    ];

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: employerBody
    });

    // Footer Note
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.text("This is a system generated payslip.", pageWidth / 2, finalY, { align: "center" });

    // Save
    const blob = new Blob([doc.output("arraybuffer")], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Payslip_${record.employee.epf_number}_${monthName}_${payrollYear}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  // useEffect(() => {
  //   fetchRecordsByMonthAndYear();
  // }, [selectedMonth, selectedYear]);

  useEffect(() => {
    if (!searchMonth || !searchYear) return;

    const fetchByPeriod = async () => {
      const records = await fetchPayrollBySearch({
        setLoading,
        month: searchMonth,
        year: searchYear,
      });

      if (records) {
        setPayrollData(records.data);
      } else {
        setPayrollData([]);
      }
    };

    fetchByPeriod();
  }, [searchMonth, searchYear]);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setCurrentPage(1);
    const previousMonth = value === 1 ? 12 : value - 1;
    const yearForPreviousMonth = value === 1 ? selectedYear - 1 : selectedYear;
    const startDate = `${yearForPreviousMonth}-${String(previousMonth).padStart(2, "0")}-19`;
    const endDate = `${selectedYear}-${String(value).padStart(2, "0")}-18`;
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleSearchMonthChange = (value) => {
    setSearchMonth(value);
    setCurrentPage(1);
  };

  const columns = [
    {
      title: "EPF Number",
      dataIndex: ["employee", "epf_number"],
      key: "epf_number",
    },
    {
      title: "Name",
      dataIndex: "employee",
      key: "name",
      render: (employee) => {
        if (employee && employee.full_name) {
          return employee.full_name;
        } else if (employee && employee.first_name && employee.last_name) {
          return `${employee.first_name} ${employee.last_name}`;
        }
        return "-";
      },
    },
    {
      title: "Center",
      dataIndex: ["employee", "center"],
      key: "center",
    },
    {
      title: "Branch",
      dataIndex: ["employee", "branch"],
      key: "branch",
    },
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "OT",
      dataIndex: "overtimePay",
      key: "overtimePay",
      render: (text, record) => {
        const isEditable = isEditing(record);
        return isEditable ? (
          <Input
            value={editedOvertime[record._id] || record.overtimePay || "0"}
            onChange={(e) => handleOvertimeChange(e.target.value, record._id)}
            type="number"
            min="0"
            style={{ width: 100 }}
          />
        ) : (
          <span>{record.overtimePay === "0" ? "-" : record.overtimePay}</span>
        );
      },
    },
    {
      title: "Total Pay",
      dataIndex: "totalPay",
      key: "totalPay",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <div className="d-flex">
          <Link
            className={`me-2 p-2 ${user?.permissions && hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                ? ""
                : "disabled"
              }`}
            to="#"
            onClick={() => {
              if (
                user?.permissions &&
                hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
              ) {
                generatePayslipPDF(record);
              }
            }}
            title={
              !(user?.permissions && hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip"))
                ? "You don't have permission to download payslips"
                : "Download payslip"
            }
          >
            <i data-feather="download" className="feather-download"></i>
          </Link>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="sms"
                  onClick={() => handleSendIndividualSMS(record)}
                  disabled={
                    !user?.permissions ||
                    !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                  }
                >
                  <SendOutlined style={{ marginRight: "6px" }} /> SMS
                </Menu.Item>
                <Menu.Item
                  key="email"
                  onClick={() => handleSendPayslip(record._id)}
                  disabled={
                    !user?.permissions ||
                    !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                  }
                >
                  <MailOutlined style={{ marginRight: "6px" }} /> Email
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <Button
              type="text"
              icon={<SendOutlined />}
              disabled={
                !user?.permissions ||
                !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
              }
              title={
                !(user?.permissions && hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip"))
                  ? "You don't have permission to send payslips"
                  : "Send payslip"
              }
            />
          </Dropdown>
          <Button
            type="text"
            icon={<EyeOutlined style={{ color: "#1890ff" }} />}
            onClick={() => handleViewNoPay(record)}
            title="View No Pay Breakdown"
            style={{ padding: "4px 8px" }}
          />
          {isEditing(record) ? (
            <>
              <Button
                type="text"
                icon={<SaveOutlined />}
                onClick={() => saveOvertime(record)}
                style={{ marginLeft: 8 }}
              />
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={cancelEdit}
                style={{ marginLeft: 8 }}
              />
            </>
          ) : (
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => editOvertime(record)}
              disabled={
                !user?.permissions ||
                !hasPermission(user.permissions, "HRM", "Payroll", "edit", "Payslip")
              }
              title={
                !(user?.permissions && hasPermission(user.permissions, "HRM", "Payroll", "edit", "Payslip"))
                  ? "You don't have permission to edit payslips"
                  : "Edit overtime"
              }
              style={{ marginLeft: 8 }}
            />
          )}
        </div>
      ),
    },
  ];

  const handleAllExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees Payrolls Report");

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Color fills for different column groups
    const employeeDetailsFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FAFBFB" }, // Light Blue
    };
    const basicAndOTFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "C8E6C9" }, // Light Green
    };
    const deductionsFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFF9C4" }, // Light Yellow
    };
    const allowancesFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0B2" }, // Light Orange
    };
    const totalsFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "E1BEE7" }, // Light Purple
    };

    // Collect all unique deduction types from payrollData
    const allDeductionTypes = new Set();
    payrollData.forEach((record) => {
      if (record.deductionsByType) {
        Object.keys(record.deductionsByType).forEach((type) => {
          allDeductionTypes.add(type);
        });
      }
    });

    // Get period (same for all records)
    const period = payrollData.length > 0 ? payrollData[0].period : "";

    // Define columns in the specified order
    const columns = [
      { header: "Reference\nNo", key: "ref_no", width: 15, fill: employeeDetailsFill },
      { header: "EPF\nNumber", key: "epf_number", width: 15, fill: employeeDetailsFill },
      { header: "Full\nName", key: "name", width: 40, fill: employeeDetailsFill },
      { header: "Center", key: "center", width: 15, fill: employeeDetailsFill },
      { header: "Employee\nType", key: "employee_type", width: 15, fill: employeeDetailsFill },
      { header: "Branch", key: "branch", width: 15, fill: employeeDetailsFill },
      { header: "Bank\nCode", key: "bank", width: 15, fill: employeeDetailsFill },
      { header: "Account\nNumber", key: "bank_account", width: 20, fill: employeeDetailsFill },
      { header: "Transaction\nCode", key: "transaction_code", width: 20, fill: employeeDetailsFill },
      { header: "Amount\n(Rs.)", key: "total", width: 20, fill: employeeDetailsFill },
      { header: "Basic\nSalary", key: "basicSalary", width: 15, fill: basicAndOTFill },
      { header: "Overtime\nPay", key: "overtimePay", width: 15, fill: basicAndOTFill },
      { header: "Prorated\nSalary", key: "proratedSalary", width: 15, fill: basicAndOTFill },
      { header: "Total\nBasic", key: "totalBasic", width: 15, fill: basicAndOTFill },
      { header: "Gross\nPay", key: "grossPay", width: 15, fill: basicAndOTFill },
      { header: "No Pay\nLeave", key: "noPayForLeaves", width: 15, fill: deductionsFill },
      { header: "Authorized No Pay\nLeave", key: "noPayForAuthNoPayLeaves", width: 15, fill: deductionsFill },

      { header: "No Pay\nLate", key: "noPayLateAttendance", width: 15, fill: deductionsFill },
      { header: "Total No\nPay", key: "totalNoPay", width: 15, fill: deductionsFill },

      { header: "EPF\n(8%)", key: "epf", width: 15, fill: deductionsFill },
      { header: "WS & LS\nContribution", key: "wsLsContribution", width: 15, fill: deductionsFill },
      // Dynamic deduction type columns
      ...Array.from(allDeductionTypes).map((type) => ({
        header: type.replace(/\s+/g, "\n"), // Vertical header
        key: `deduction_${type.replace(/\s+/g, "_")}`,
        width: 20,
        fill: deductionsFill,
      })),
      { header: "Total\nDeductions", key: "totalDeductions", width: 15, fill: deductionsFill },
      { header: "Payee\nTax", key: "payeeTax", width: 15, fill: deductionsFill },
      { header: "Net\nPay", key: "netPay", width: 15, fill: totalsFill },
      { header: "EPF\n(12%)", key: "epf12", width: 15, fill: totalsFill },
      { header: "EPF\n(20%)", key: "epf20", width: 15, fill: totalsFill },
      { header: "ETF\n(3%)", key: "etf3", width: 15, fill: totalsFill },
      { header: "Allowance\n1000", key: "allowance1000", width: 15, fill: allowancesFill },
      { header: "Allowance\n2500", key: "allowance2500", width: 15, fill: allowancesFill },
      { header: "Budgetary\nAllowance", key: "budgetaryAllowance", width: 15, fill: allowancesFill },
      { header: "Other\nAllowances", key: "otherAllowances", width: 15, fill: allowancesFill },
      { header: "Total\nPay", key: "totalPay", width: 15, fill: totalsFill },
    ];

    // Set worksheet columns
    worksheet.columns = columns.map(({ header, key, width }) => ({ header, key, width }));

    // Add period row at the top
    if (period) {
      worksheet.mergeCells(1, 1, 1, columns.length);
      const periodRow = worksheet.getRow(1);
      periodRow.getCell(1).value = `Period: ${period}`;
      periodRow.getCell(1).font = { bold: true, size: 12 };
      periodRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      periodRow.getCell(1).border = borderStyle;
      periodRow.height = 30;
    }

    // Set header row (now on row 2 due to period row)
    const headerRow = worksheet.getRow(2);
    headerRow.values = columns.map((col) => col.header);
    headerRow.eachCell((cell, colNumber) => {
      cell.fill = columns[colNumber - 1].fill;
      cell.border = borderStyle;
      cell.font = { bold: true, size: 10 };
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true, textRotation: 90 };
    });
    headerRow.height = 100; // Increased height for vertical headers

    // Add data rows
    payrollData
      .filter((record) => record && record.employee)
      .forEach((record, index) => {
        const rowData = {
          ref_no: index + 1,
          epf_number: record.employee.epf_number || "",
          name:
            record?.employee.full_name ||
            `${record?.employee.first_name || ""} ${record?.employee.last_name || ""}`,
          center: record.employee.center || "",
          employee_type: record.employee.employee_type || "",
          branch: record.employee.branch || "",
          bank: record.employee.bank || "",
          bank_account: record.employee.account_number || "",
          transaction_code: "023-Salaries",
          total: record?.netPay ? Number.parseFloat(record.netPay).toFixed(2) : "0.00",
          basicSalary: record.basicSalary ? Number.parseFloat(record.basicSalary).toFixed(2) : "0.00",
          overtimePay: record.overtimePay ? Number.parseFloat(record.overtimePay).toFixed(2) : "0.00",
          proratedSalary: record.proratedSalary ? Number.parseFloat(record.proratedSalary).toFixed(2) : "0.00",
          totalBasic: record.totalBasic ? Number.parseFloat(record.totalBasic).toFixed(2) : "0.00",
          grossPay: record.grossPay ? Number.parseFloat(record.grossPay).toFixed(2) : "0.00",
          noPayForLeaves: record.noPayForLeaves ? Number.parseFloat(record.noPayForLeaves).toFixed(2) : "0.00",
          noPayForAuthNoPayLeaves: record.noPayForAuthNoPayLeaves ? Number.parseFloat(record.noPayForAuthNoPayLeaves).toFixed(2) : "0.00",
          noPayLateAttendance: record.noPayLateAttendance ? Number.parseFloat(record.noPayLateAttendance).toFixed(2) : "0.00",
          totalNoPay: record.totalNoPay ? Number.parseFloat(record.totalNoPay).toFixed(2) : "0.00",

          epf: record.epf ? Number.parseFloat(record.epf).toFixed(2) : "0.00",
          wsLsContribution: record.wsLsContribution ? Number.parseFloat(record.wsLsContribution).toFixed(2) : "0.00",
          totalDeductions: record.totalDeductions ? Number.parseFloat(record.totalDeductions).toFixed(2) : "0.00",
          payeeTax: record.payeeTax ? Number.parseFloat(record.payeeTax).toFixed(2) : "0.00",
          netPay: record.netPay ? Number.parseFloat(record.netPay).toFixed(2) : "0.00",
          epf12: record.epf12 ? Number.parseFloat(record.epf12).toFixed(2) : "0.00",
          epf20: record.epf20 ? Number.parseFloat(record.epf20).toFixed(2) : "0.00",
          etf3: record.etf3 ? Number.parseFloat(record.etf3).toFixed(2) : "0.00",
          allowance1000: record.allowance1000 ? Number.parseFloat(record.allowance1000).toFixed(2) : "0.00",
          allowance2500: record.allowance2500 ? Number.parseFloat(record.allowance2500).toFixed(2) : "0.00",
          budgetaryAllowance: record.budgetaryAllowance ? Number.parseFloat(record.budgetaryAllowance).toFixed(2) : "0.00",
          otherAllowances: record.otherAllowances ? Number.parseFloat(record.otherAllowances).toFixed(2) : "0.00",
          totalPay: record.totalPay ? Number.parseFloat(record.totalPay).toFixed(2) : "0.00",
        };

        // Add dynamic deduction type values
        Array.from(allDeductionTypes).forEach((type) => {
          const key = `deduction_${type.replace(/\s+/g, "_")}`;
          rowData[key] = record.deductionsByType?.[type]
            ? Number.parseFloat(record.deductionsByType[type]).toFixed(2)
            : "0.00";
        });

        const row = worksheet.addRow(rowData);

        // Apply alignment and fills
        columns.forEach((col) => {
          const cell = row.getCell(col.key);
          cell.border = borderStyle;
          cell.fill = col.fill;
          if (["ref_no", "epf_number", "center", "employee_type", "branch", "bank_code", "bank_account", "transaction_code"].includes(col.key)) {
            cell.alignment = { horizontal: "center" };
          } else {
            cell.alignment = { horizontal: "right" };
          }
        });
      });

    // Generate and download Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `OKI_Payrolls_Report_${selectedYear}_${selectedMonth}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const handleOKIDSExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees Payrolls Report (OKIDS)");

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D3D3D3" },
    };

    worksheet.mergeCells("A1:A2");
    worksheet.mergeCells("B1:B2");
    worksheet.mergeCells("C1:C2");
    worksheet.mergeCells("D1:D2");
    worksheet.mergeCells("E1:E2");
    worksheet.mergeCells("F1:F2");

    const headerRow = worksheet.getRow(1);
    headerRow.values = [
      "Name",
      "Account Number",
      "Bank Code",
      "Branch Code",
      "Total",
      "EPF Number",
    ];

    headerRow.eachCell((cell) => {
      cell.fill = headerFill;
      cell.border = borderStyle;
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    worksheet.columns = [
      { key: "name", width: 30 },
      { key: "bank_account", width: 20 },
      { key: "bank_code", width: 10 },
      { key: "branch_code", width: 15 },
      { key: "total", width: 20 },
      { key: "epf_number", width: 15 },
    ];

    const filteredPayrollData = payrollData.filter(
      (record) => record.employee.center === "OKIDS"
    );

    filteredPayrollData.forEach((record, index) => {
      const rowNumber = 3 + index;
      worksheet.addRow({
        name:
          record?.employee.full_name ||
          `${record?.employee.first_name || ""} ${record?.employee.last_name || ""
          }`,
        bank_account: record.employee.account_number,
        bank_code: record.employee.bank_code,
        branch_code: record.employee.branch_code,
        total: record?.netPay
          ? Number.parseFloat(record.netPay).toFixed(2)
          : "0.00",
        epf_number: record.employee.epf_number,
      });

      const row = worksheet.getRow(rowNumber);
      row.getCell("total").alignment = { horizontal: "right" };
      row.getCell("bank_code").alignment = { horizontal: "center" };
      row.getCell("branch_code").alignment = { horizontal: "center" };
      row.getCell("epf_number").alignment = { horizontal: "center" };
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.row >= 1) {
          cell.border = borderStyle;
        }
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `OKIDS_Payrolls_Report.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const downloadOKIDSETFFile = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("OKIDS ETF Report");
    worksheet.views = [{ state: "frozen", ySplit: 3 }];

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D3D3D3" },
    };

    worksheet.mergeCells("A1:A3");
    worksheet.mergeCells("B1:B3");
    worksheet.mergeCells("C1:C3");
    worksheet.mergeCells("D1:D3");
    worksheet.mergeCells("E1:E3");
    worksheet.mergeCells("F1:F3");
    worksheet.mergeCells("G1:G3");
    worksheet.mergeCells("H1:H3");

    const headerRow = worksheet.getRow(1);
    headerRow.values = [
      "NIC/Passport\nNumber",
      "Surname",
      "Initials",
      "Member\nNumber",
      "Total\nContribution",
      "Employee\nNumber",
      "Contribution\nFrom Period\n(YYYY/MM/DD)",
      "Contribution\nTo Period\n(YYYY/MM/DD)",
    ];

    headerRow.eachCell((cell) => {
      cell.fill = headerFill;
      cell.border = borderStyle;
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    worksheet.columns = [
      { key: "nic", width: 20 },
      { key: "surname", width: 20 },
      { key: "initials", width: 15 },
      { key: "member_num", width: 15 },
      { key: "total_contribution", width: 15 },
      { key: "employee_number", width: 15 },
      { key: "to_period", width: 15 },
      { key: "from_period", width: 15 },
    ];

    const getInitials = (name) => {
      const nameParts = name.split(" ");
      const initials = nameParts
        .slice(0, -1)
        .map((part) => part.charAt(0).toUpperCase())
        .join(" ");
      return initials;
    };

    const getSurname = (name) => {
      const nameParts = name.split(" ");
      return nameParts[nameParts.length - 1];
    };

    payrollData.forEach((record, index) => {
      const rowNumber = 3 + index;
      worksheet.addRow({
        nic: record.employee.nic,
        surname: getSurname(
          record?.employee.full_name ||
          `${record?.employee.first_name || ""} ${record?.employee.last_name || ""
          }`
        ),
        initials: getInitials(
          record?.employee.full_name ||
          `${record?.employee.first_name || ""} ${record?.employee.last_name || ""
          }`
        ),
        member_num: record.employee.epf_number,
        total_contribution: record.etf3,
        employee_number: "I 013188",
        to_period: `${record.year}${record.month}`,
        from_period: `${record.year}${record.month}`,
      });

      const row = worksheet.getRow(rowNumber);
      row.getCell("total_contribution").alignment = { horizontal: "right" };
      row.getCell("member_num").alignment = { horizontal: "center" };
      row.getCell("employee_number").alignment = { horizontal: "center" };
      row.getCell("to_period").alignment = { horizontal: "center" };
      row.getCell("from_period").alignment = { horizontal: "center" };
      row.getCell("total_contribution").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E0F7FA" },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.row >= 1) {
          cell.border = borderStyle;
        }
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ETF_Report.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const downloadOKIDSEPFFile = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("OKIDS EPF Report");
    worksheet.views = [{ state: "frozen", ySplit: 3 }];

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D3D3D3" },
    };

    worksheet.mergeCells("A1:A3");
    worksheet.mergeCells("B1:B3");
    worksheet.mergeCells("C1:C3");
    worksheet.mergeCells("D1:D3");
    worksheet.mergeCells("E1:E3");
    worksheet.mergeCells("F1:F3");
    worksheet.mergeCells("G1:G3");
    worksheet.mergeCells("H1:H3");
    worksheet.mergeCells("I1:I3");
    worksheet.mergeCells("J1:J3");
    worksheet.mergeCells("K1:K3");
    worksheet.mergeCells("L1:L3");
    worksheet.mergeCells("M1:M3");
    worksheet.mergeCells("N1:N3");
    worksheet.mergeCells("O1:O3");

    const headerRow = worksheet.getRow(1);
    headerRow.values = [
      "NIC/Passport\nNumber",
      "Surname",
      "Initials",
      "Member\nNumber",
      "Total\nContribution",
      "Employer's\nContribution",
      "Member's\nContribution",
      "Total Earnings",
      "Member Status \n E=Extg, N=New, V=Vacated",
      "Zone",
      "Employer\nNumber",
      "Contribution\n Period\n (YYYY/MM)",
      "Data Submission\nNumber",
      "No. of Days\nWorked",
      "Occupation\nClassification\nGrade",
    ];

    headerRow.eachCell((cell) => {
      cell.fill = headerFill;
      cell.border = borderStyle;
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    worksheet.columns = [
      { key: "nic", width: 20 },
      { key: "surname", width: 20 },
      { key: "initials", width: 15 },
      { key: "member_num", width: 15 },
      { key: "total_contribution", width: 15 },
      { key: "employer_contribution", width: 15 },
      { key: "member_contribution", width: 15 },
      { key: "total_earning", width: 15 },
      { key: "member_status", width: 15 },
      { key: "zone", width: 15 },
      { key: "employer_number", width: 15 },
      { key: "contribution_period", width: 15 },
      { key: "data_sub_num", width: 15 },
      { key: "work_days", width: 15 },
      { key: "occupation_clss_gde", width: 15 },
    ];

    const getInitials = (name) => {
      const nameParts = name.split(" ");
      const initials = nameParts
        .slice(0, -1)
        .map((part) => part.charAt(0).toUpperCase())
        .join(" ");
      return initials;
    };

    const getSurname = (name) => {
      const nameParts = name.split(" ");
      return nameParts[nameParts.length - 1];
    };

    payrollData.forEach((record, index) => {
      const rowNumber = 3 + index;
      worksheet.addRow({
        nic: record.employee.nic,
        surname: getSurname(
          record?.employee.full_name ||
          `${record?.employee.first_name || ""} ${record?.employee.last_name || ""
          }`
        ),
        initials: getInitials(
          record?.employee.full_name ||
          `${record?.employee.first_name || ""} ${record?.employee.last_name || ""
          }`
        ),
        member_num: record.employee.epf_number,
        total_contribution: toTwoDecimalNumber(record.epf20),
        employer_contribution: toTwoDecimalNumber(record.epf12),
        member_contribution: toTwoDecimalNumber(record.epf),
        total_earning: toTwoDecimalNumber(record?.netPay),
        member_status: "E",
        zone: "I",
        employer_number: "13188",
        contribution_period: `${record.month}${record.year}`,
        data_sub_num: "1",
        work_days: getVerifiedWorkDays(record),
        occupation_clss_gde: "23",
      });

      const row = worksheet.getRow(rowNumber);
      row.getCell("total_contribution").alignment = { horizontal: "right" };
      row.getCell("total_earning").alignment = { horizontal: "right" };
      row.getCell("member_num").alignment = { horizontal: "center" };
      row.getCell("employer_contribution").alignment = { horizontal: "right" };
      row.getCell("member_contribution").alignment = { horizontal: "right" };
      row.getCell("member_status").alignment = { horizontal: "center" };
      row.getCell("zone").alignment = { horizontal: "center" };
      row.getCell("employer_number").alignment = { horizontal: "center" };
      row.getCell("contribution_period").alignment = { horizontal: "center" };
      row.getCell("data_sub_num").alignment = { horizontal: "center" };
      row.getCell("work_days").alignment = { horizontal: "center" };
      row.getCell("occupation_clss_gde").alignment = { horizontal: "center" };

      row.getCell("total_contribution").numFmt = "#,##0.00";
      row.getCell("employer_contribution").numFmt = "#,##0.00";
      row.getCell("member_contribution").numFmt = "#,##0.00";
      row.getCell("total_earning").numFmt = "#,##0.00";

      row.getCell("total_contribution").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E0F7FA" },
      };
      row.getCell("employer_contribution").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E0F7FA" },
      };
      row.getCell("member_contribution").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E0F7FA" },
      };
      row.getCell("total_earning").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E0F7FA" },
      };
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        if (cell.row >= 1) {
          cell.border = borderStyle;
        }
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `EPF_Report.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="page-wrapper-lt">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="header-leave-container ">
              <div>
                <ArrowLeft size={32} />
              </div>
              <div className="page-title">
                <h4>Payrolls Management</h4>
                <h6>Manage Employee payrolls </h6>
              </div>
            </div>
            <div className="page-btn" style={{ marginRight: "40px" }}>
              <div className="wordset" style={{ marginLeft: "auto", marginRight: "10px" }}>
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <Button
                    style={{ width: 200, height: 35 }}
                    disabled={
                      !user?.permissions ||
                      !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                    }
                    title={
                      !(user?.permissions && hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip"))
                        ? "You don't have permission to download files"
                        : "Download payslip files"
                    }
                  >
                    Download Files <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div
              className="container mt-3"
              style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}
            >
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                <div className="col-12 col-md-3 text-start">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    value={search}
                    className="form-control"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    style={{ width: "85%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-1 mb-3 text-start">
                  <label className="form-label">EPF No</label>
                  <input
                    className="form-control"
                    type="text"
                    value={epf_number}
                    onChange={(e) => setEpf(e.target.value)}
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Center</label>
                  <Select
                    value={center}
                    options={centerOption}
                    className="select"
                    placeholder="Select Center"
                    onChange={setCenter}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Branch</label>
                  <Select
                    value={branch}
                    options={branchOptions}
                    className="select"
                    placeholder="Select Branch"
                    onChange={setBranch}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Year</label>
                  <DatePicker
                    picker="year"
                    onChange={handleSearchYearChange}
                    placeholder="Select Year"
                    size="large"
                    style={{ width: "100%", borderRadius: 8 }}
                    allowClear
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Month</label>
                  <Select
                    placeholder="Select Month"
                    value={searchMonth}
                    style={{ width: "100%" }}
                    size={"large"}
                    onChange={handleSearchMonthChange}
                    allowClear
                  >
                    <Option value={1} disabled={(!searchYear || searchYear === currentYear) ? 1 > currentMonth + 1 : searchYear > currentYear}>
                      January
                    </Option>
                    <Option value={2} disabled={(!searchYear || searchYear === currentYear) ? 2 > currentMonth + 1 : searchYear > currentYear}>
                      February
                    </Option>
                    <Option value={3} disabled={(!searchYear || searchYear === currentYear) ? 3 > currentMonth + 1 : searchYear > currentYear}>
                      March
                    </Option>
                    <Option value={4} disabled={(!searchYear || searchYear === currentYear) ? 4 > currentMonth + 1 : searchYear > currentYear}>
                      April
                    </Option>
                    <Option value={5} disabled={(!searchYear || searchYear === currentYear) ? 5 > currentMonth + 1 : searchYear > currentYear}>
                      May
                    </Option>
                    <Option value={6} disabled={(!searchYear || searchYear === currentYear) ? 6 > currentMonth + 1 : searchYear > currentYear}>
                      June
                    </Option>
                    <Option value={7} disabled={(!searchYear || searchYear === currentYear) ? 7 > currentMonth + 1 : searchYear > currentYear}>
                      July
                    </Option>
                    <Option value={8} disabled={(!searchYear || searchYear === currentYear) ? 8 > currentMonth + 1 : searchYear > currentYear}>
                      August
                    </Option>
                    <Option value={9} disabled={(!searchYear || searchYear === currentYear) ? 9 > currentMonth + 1 : searchYear > currentYear}>
                      September
                    </Option>
                    <Option value={10} disabled={(!searchYear || searchYear === currentYear) ? 10 > currentMonth + 1 : searchYear > currentYear}>
                      October
                    </Option>
                    <Option value={11} disabled={(!searchYear || searchYear === currentYear) ? 11 > currentMonth + 1 : searchYear > currentYear}>
                      November
                    </Option>
                    <Option value={12} disabled={(!searchYear || searchYear === currentYear) ? 12 > currentMonth + 1 : searchYear > currentYear}>
                      December
                    </Option>
                  </Select>
                </div>

              </div>
            </div>

            <div
              className="container mt-0"
              style={{ maxWidth: "100%", marginLeft: "20px", marginRight: "40px" }}
            >
              <div className="row d-flex align-items-center justify-content-start">
                <div className="col-12 col-md-2 mb-3 text-start">
                  <button
                    disabled={loading}
                    className="btn btn-submit"
                    onClick={handleSearch}
                    style={{ height: "38px", width: "55%" }}
                  >
                    {loading ? "Search " : "Search"}
                  </button>
                  {loading ? (
                    <div className="spinner">
                      <div className="loading-circle"></div>
                    </div>
                  ) : (
                    <div>{/* Render Data Here */}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card table-list-card-grid">
          <div className="card-body" style={{ maxWidth: "100%", marginRight: "20px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                padding: "10px",
              }}
            >
              <div>{/* Optional content on the left */}</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <div>
                  <DatePicker
                    picker="year"
                    onChange={handleYearChange}
                    defaultValue={dayjs(`${currentYear}`, "YYYY")}
                    placeholder="Select Year"
                    size="large"
                    style={{ width: "100%", borderRadius: 8 }}
                  />
                </div>
                <div>
                  <Select
                    value={selectedMonth}
                    style={{ width: "100%" }}
                    size={"large"}
                    onChange={handleMonthChange}
                  >
                    <Option value={1}>January</Option>
                    <Option value={2}>February</Option>
                    <Option value={3}>March</Option>
                    <Option value={4}>April</Option>
                    <Option value={5}>May</Option>
                    <Option value={6}>June</Option>
                    <Option value={7}>July</Option>
                    <Option value={8}>August</Option>
                    <Option value={9}>September</Option>
                    <Option value={10}>October</Option>
                    <Option value={11}>November</Option>
                    <Option value={12}>December</Option>
                  </Select>
                </div>

                <div>
                  <button className="btn btn-submit" onClick={generatePayrolls}>
                    {loading2 ? (
                      <>
                        <Spin size="small" /> <span>Please wait...</span>
                      </>
                    ) : (
                      "Generate Payroll"
                    )}
                  </button>
                </div>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="bulk-sms"
                        onClick={handleSendBulkSMS}
                        disabled={
                          !payrollData.length ||
                          !user?.permissions ||
                          !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                        }
                      >
                        <SendOutlined style={{ marginRight: "6px" }} /> SMS
                      </Menu.Item>
                      <Menu.Item
                        key="bulk-email"
                        onClick={handleBulkSend}
                        disabled={
                          !payrollData.length ||
                          !user?.permissions ||
                          !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                        }
                      >
                        <MailOutlined style={{ marginRight: "6px" }} /> Email
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <Button
                    type="primary"
                    icon={<SendOutlined />}
                    disabled={
                      !payrollData.length ||
                      !user?.permissions ||
                      !hasPermission(user.permissions, "HRM", "Payroll", "download", "Payslip")
                    }
                    style={{ height: "38px", backgroundColor: "gray" }}
                  >
                    Send All
                  </Button>
                </Dropdown>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={payrollData}
                rowKey="_id" pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  showSizeChanger: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                  position: ["bottomCenter"],
                  showQuickJumper: true,
                }}
                loading={loading}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* No Pay Breakdown Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <EyeOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
            <span>No Pay Calculation Breakdown</span>
          </div>
        }
        open={isNoPayModalVisible}
        onCancel={() => {
          setIsNoPayModalVisible(false);
          setNoPayData(null);
        }}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => {
              setIsNoPayModalVisible(false);
              setNoPayData(null);
            }}
          >
            Close
          </Button>
        ]}
        width={1000}
        destroyOnClose
      >
        {noPayLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" tip="Loading No Pay Breakdown..." />
          </div>
        ) : noPayData ? (
          <div>
            {/* Employee & Payroll Header Card */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "16px",
                borderRadius: "8px",
                marginBottom: "20px",
                border: "1px solid #e9ecef"
              }}
            >
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                <div>
                  <strong>Employee:</strong> {noPayData.summary?.employeeName} ({noPayData.summary?.epfNumber})
                </div>
                <div>
                  <strong>Employee Type:</strong> {noPayData.summary?.employeeType} ({noPayData.summary?.workingHoursPerDay} hrs/day)
                </div>
                <div>
                  <strong>Salary Period:</strong> {noPayData.summary?.period}
                </div>
                <div>
                  <strong>Total Basic Salary:</strong> LKR {noPayData.summary?.totalBasic?.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
                <div>
                  <strong>Daily Rate (Basic/30):</strong> LKR {noPayData.summary?.dailyRate?.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
                <div>
                  <strong>Per Minute Rate:</strong> LKR {noPayData.summary?.perMinuteRate?.toFixed(4)}
                </div>
              </div>
            </div>

            {/* Summary Stat Badges */}
            <div style={{ display: "flex", gap: "12px", marginBottom: "20px", flexWrap: "wrap" }}>
              <div style={{ flex: 1, backgroundColor: "#fff0f6", border: "1px solid #ffadd2", padding: "12px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#c41d7f" }}>Unpaid Absences</div>
                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#9e1068" }}>
                  {noPayData.summary?.unpaidLeaveDaysCount} Days
                </div>
                <div style={{ fontSize: "12px", color: "#c41d7f" }}>
                  LKR {Number(noPayData.summary?.noPayForLeaves || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
              </div>

              <div style={{ flex: 1, backgroundColor: "#e6f7ff", border: "1px solid #91d5ff", padding: "12px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#096dd9" }}>Authorized No Pay</div>
                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0050b3" }}>
                  {noPayData.summary?.authorizedNoPayDaysCount} Days
                </div>
                <div style={{ fontSize: "12px", color: "#096dd9" }}>
                  LKR {Number(noPayData.summary?.noPayForAuthNoPayLeaves || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
              </div>

              <div style={{ flex: 1, backgroundColor: "#fffbe6", border: "1px solid #ffe58f", padding: "12px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#d48806" }}>Late Attendance</div>
                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#ad6800" }}>
                  {noPayData.summary?.lateHoursFormatted}
                </div>
                <div style={{ fontSize: "12px", color: "#d48806" }}>
                  LKR {Number(noPayData.summary?.noPayLateAttendance || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
              </div>

              <div style={{ flex: 1, backgroundColor: "#f6ffed", border: "1px solid #b7eb8f", padding: "12px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#389e0d" }}>Total No Pay Deduction</div>
                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#237804" }}>
                  LKR {Number(noPayData.summary?.totalNoPay || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </div>
              </div>
            </div>

            {/* Day by Day Table */}
            <h6 style={{ marginBottom: "10px", fontWeight: "bold" }}>Day-by-Day No Pay Breakdown</h6>
            {noPayData.dayByDayBreakdown && noPayData.dayByDayBreakdown.length > 0 ? (
              <Table
                dataSource={noPayData.dayByDayBreakdown}
                rowKey={(record, index) => `${record.date}-${index}`}
                pagination={false}
                size="small"
                bordered
                columns={[
                  { title: "Date", dataIndex: "date", key: "date" },
                  { title: "Day", dataIndex: "dayOfWeek", key: "dayOfWeek" },
                  {
                    title: "Type",
                    dataIndex: "type",
                    key: "type",
                    render: (text) => (
                      <span
                        style={{
                          padding: "2px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "500",
                          backgroundColor: text?.includes("Authorized") ? "#e6f7ff" : "#fff0f6",
                          color: text?.includes("Authorized") ? "#1890ff" : "#ff4d4f",
                          border: `1px solid ${text?.includes("Authorized") ? "#91d5ff" : "#ffadd2"}`
                        }}
                      >
                        {text}
                      </span>
                    )
                  },
                  { title: "Reason / Details", dataIndex: "reason", key: "reason" },
                  {
                    title: "Count",
                    dataIndex: "count",
                    key: "count",
                    render: (val) => `${val} Day${val > 1 ? 's' : ''}`
                  },
                  {
                    title: "Deduction (LKR)",
                    dataIndex: "amount",
                    key: "amount",
                    render: (val) => (
                      <strong style={{ color: "#cf1322" }}>
                        {Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                      </strong>
                    )
                  }
                ]}
              />
            ) : (
              <div style={{ padding: "16px", backgroundColor: "#fafafa", borderRadius: "6px", textAlign: "center", color: "#8c8c8c" }}>
                No day-by-day leave deductions recorded for this period.
              </div>
            )}

            {/* Late Attendance Details */}
            {noPayData.lateDetails && noPayData.lateDetails.lateMinutes > 0 && (
              <div style={{ marginTop: "20px" }}>
                <h6 style={{ marginBottom: "10px", fontWeight: "bold" }}>Late Attendance Breakdown</h6>

                {/* Day-by-day late table */}
                {noPayData.lateBreakdown && noPayData.lateBreakdown.length > 0 ? (
                  <Table
                    dataSource={noPayData.lateBreakdown}
                    rowKey={(record, index) => `${record.date}-${index}`}
                    pagination={false}
                    size="small"
                    bordered
                    style={{ marginBottom: "12px" }}
                    columns={[
                      { title: "Date", dataIndex: "date", key: "date" },
                      { title: "Day", dataIndex: "dayOfWeek", key: "dayOfWeek" },
                      { title: "Shift", key: "shift", render: (_, rec) => `${rec.shiftFrom} - ${rec.shiftTo}` },
                      { title: "Clock In", dataIndex: "clockIn", key: "clockIn" },
                      { title: "Clock Out", dataIndex: "clockOut", key: "clockOut" },
                      {
                        title: "Late",
                        key: "late",
                        render: (_, rec) => (
                          <span style={{ color: "#d48806", fontWeight: 500 }}>
                            {rec.lateFormatted} ({rec.lateMinutes} mins)
                          </span>
                        )
                      },
                      {
                        title: "Deduction (LKR)",
                        dataIndex: "deduction",
                        key: "deduction",
                        render: (val) => (
                          <strong style={{ color: "#cf1322" }}>
                            {Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                          </strong>
                        )
                      }
                    ]}
                  />
                ) : (
                  <div style={{ padding: "12px", backgroundColor: "#fafafa", borderRadius: "6px", textAlign: "center", color: "#8c8c8c", marginBottom: "12px" }}>
                    No late attendance records for this period.
                  </div>
                )}

                {/* Late Summary Footer */}
                <div style={{ padding: "12px", backgroundColor: "#fffbe6", borderRadius: "6px", border: "1px solid #ffe58f" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                    <span>Total Late Time: <strong>{noPayData.lateDetails.lateHours}</strong> ({noPayData.lateDetails.lateMinutes} mins)</span>
                    <span>Rate / min: <strong>LKR {noPayData.lateDetails.perMinuteRate}</strong></span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Working Hours Standard: <strong>{noPayData.lateDetails.workingHoursPerDay} Hours/Day</strong></span>
                    <span>Late No Pay Deduction: <strong style={{ color: "#cf1322" }}>LKR {Number(noPayData.lateDetails.deductionAmount).toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong></span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
            No data available
          </div>
        )}
      </Modal>
    </div>
  );
}

export default Payslip;